/**
 * feature-config flag names owned by site-reliability
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const SITE_RELIABILITY_FLAG_NAMES = {
  CLOUDFLARE_HOSTING: 'ff-rel-2956-cloudflare-custom-domains',
  DL_ENHANCEMENTS: 'ff-dataloss-enhancements',
  CACHE_CONTROL_TO_DOM_ENDPOINTS:
    'ff-dperf-289-add-cache-control-to-dom-endpoints',
  SEND_DOM_VERSION: 'ff-dataloss-send-dom-version',
  // INCIDENT inc-1041: Skip maintenance snapshot for large sites causing OOM during migration
  SKIP_MAINTENANCE_BACKUP_SITE_VERSION:
    'ff-struct-3445-skip-maintenance-backup-site-version',
  DNS_VERIFICATION_RETRY: 'ff-sre-946-dns-verification-retry',
};
